import React from 'react'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
import { withRouter, NavLink } from 'react-router-dom'
import { media } from 'modules/common/components/ui/utils'
import withLocalized from 'modules/localization/withLocalized'
import Icon from 'modules/common/components/icon/Icon'
import { ICONS } from 'modules/common/components/icon/Icons'

const Footer = styled.div`
  background: #292929;
  height: auto;
  padding: 1rem 0 0 0;
  ${media.tabletNarrow`
    height: auto;
    padding: 2.7rem 0 0 0;
  `}
  .current-input-mouse & {
    a:hover {
      text-decoration: underline;
    }
  }
`;

const Links = styled.footer`
  color: #9b9b9b;
  font-size: 0.875rem;
  margin-top: 1rem;
  line-height: 1.5rem;
  width: 100%;
  background: rgba(74, 74, 74, 0.3);
  padding: 2.375em;
`;

const ShareLinks = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 1rem;
  padding-left: 0;
  list-style: none;
  flex-flow: row wrap;
`;

const ShareLink = styled.li`
  background: white;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 100%;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5em;
  margin-bottom: 1.75em;
  cursor: pointer;

  .current-input-mouse & {
    &:hover {
      background: rgba(225, 225, 225, 1);
      svg {
        fill: #000;
      }
    }
  }

  svg {
    fill: #292929;
    opacity: 0.8;
    width: 1.25rem;
    height: 1.25rem;
  }
`;

const onFacebookClick = () => {
  window.open("https://www.facebook.com/BirdietimeApp/", "_blank");
};

const onTwitterClick = () => {
  window.open("https://twitter.com/birdietimeapp", "_blank");
};

const AppFooter = props => {
  const { localized } = props;

  return (
    <Footer>
        <Links>
        <MediaQuery minWidth={768}>
          <ShareLinks>
            <ShareLink onClick={onFacebookClick}>
              <Icon icon={ICONS.FACEBOOK} />
            </ShareLink>
            <ShareLink onClick={onTwitterClick}>
              <Icon icon={ICONS.TWITTER} />
            </ShareLink>
          </ShareLinks>
        </MediaQuery>
        <p className="text--center">
          {localized("nav.copyright")}{" "}
          <NavLink to="/terms">{localized("nav.site_terms")}</NavLink>
        </p>
      </Links>
    </Footer>
  );
};

export default withLocalized(withRouter(AppFooter));



// WEBPACK FOOTER //
// ./src/modules/common/components/app/AppFooter.js